import {HighlightSlider} from "thalia-molecules/produktlisten/slider";

const THEMENWELT_HIGHLIGHTSLIDER_CUSTOM_ELEMENT = "themenwelt-highlightslider";

class ThemenweltHighlightslider extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector(".tm-produktliste-highlight");
        this.controlsContainer = this.querySelector(".tm-controls-container__navigation");
        this.marker = this.querySelector(".tm-controls-container__marker");
        this.highlightSlider = new HighlightSlider(this.slider, this.controlsContainer, this.marker);
    }

    connectedCallback() {
        this.highlightSlider.init();
    }
}

const customElementDefined = customElements.get(THEMENWELT_HIGHLIGHTSLIDER_CUSTOM_ELEMENT);
if (!customElementDefined) {
    customElements.define(THEMENWELT_HIGHLIGHTSLIDER_CUSTOM_ELEMENT, ThemenweltHighlightslider);
}
